import { useEffect, useRef, useState, useCallback } from 'react';
import { useAppMessage, useActiveParticipant } from '@daily-co/daily-react';
import * as PIXI from 'pixi.js';
import { useRecoilState, useRecoilValue } from 'recoil';
import { webcamAtom, reactionAtom, screenShareAtom } from '../../State';
import { Assets } from '@pixi/assets';
export default function Reaction({ app, id, isMe, eachWidthRef, modelRef }) {
  const sendAppMessage = useAppMessage();
  const [screenShareState, setScreenShareState] = useRecoilState(screenShareAtom);
  const reactionState = useRecoilValue(reactionAtom);

  //リアクションの処理
  useAppMessage({
    //下記のCallbackないは他のアバターからでも取得されるが、レンダー自体はされない
    onAppMessage: useCallback((ev) => {
      //イベントタイプがfaceで送信先のUserIDと現在のUserIDが一致するとき
      if (ev.data.type == 'reaction' && ev.fromId == id) {
        //リアクションを表示
        showReaction(ev.data.reaction);
      }
    }, []),
  });

  //他社に送信
  const sendReactionValue = (reactionValue) => {
    //WebSocketでメッセージを送信
    sendAppMessage(
      {
        type: 'reaction',
        reaction: reactionValue,
      },
      '*',
    );
  };

  //リアクション
  useEffect(() => {
    if (isMe) {
      if (reactionState.time != null) {
        //リアクションを表示
        showReaction(reactionState.reactionName);

        //サーバーに送る
        sendReactionValue(reactionState.reactionName);
      }
    }
  }, [reactionState.time]);

  //リアクション表示
  async function showReaction(reaction) {
    //アニメーションロード
    //const loader = new PIXI.Loader();

    let loadURL;
    //読み込みリソース指定
    if (reaction == 'heart') {
      loadURL = '../images/reactions/heart/heartAnim.json';
    } else if (reaction == 'bye') {
      loadURL = '../images/reactions/bye/byeAnim.json';
    } else if (reaction == 'smile') {
      loadURL = '../images/reactions/smile/smileAnim.json';
    } else if (reaction == 'like') {
      loadURL = '../images/reactions/like/likeAnim.json';
    }

    const texture = await Assets.load(loadURL);

    //ロード処理
    // loader.load((_, resources) => {
    var sheet = [];

    //テクスチャを配列に入れる
    let obj = texture.textures;

    // //リソースを格納
    // if (reaction == 'heart') {
    //   obj = resources.heart.textures;
    // } else if (reaction == 'bye') {
    //   obj = resources.bye.textures;
    // } else if (reaction == 'smile') {
    //   obj = resources.smile.textures;
    // } else if (reaction == 'like') {
    //   obj = resources.like.textures;
    // }

    Object.keys(obj).forEach(function (key) {
      sheet.push(obj[key]);
    });

    let eachWidth =
      screenShareState != null ? eachWidthRef.current * 0.2 : eachWidthRef.current * 0.3;

    //スクリーンシェアの場合は頭上に表示して、通常時は中央に表示
    let y =
      screenShareState != null
        ? modelRef.current.y - eachWidth * 2
        : modelRef.current.y - eachWidthRef.current;

    //アニメーション開始
    let anim = new PIXI.AnimatedSprite(sheet);
    anim.animationSpeed = 0.5;
    anim.play();

    anim.anchor.set(0.5);
    anim.scale.set(1);
    anim.width = eachWidth;
    anim.height = eachWidth;

    //ループ回数
    if (reaction != 'bye') {
      anim.loop = false;
    } else {
      anim.loop = true;
      var count = 0;
      anim.onLoop = function () {
        count++;
        if (count == 3) {
          anim.parent.removeChild(anim);
        }
      };
    }

    anim.position.set(modelRef.current.position.x, y);

    anim.onComplete = function () {
      anim.parent.removeChild(anim);
    };

    //ステージに追加
    app.current?.stage.addChild(anim);
    // });
  }

  return false;
}
